import React from "react";
import { Handle } from "reactflow";
import "./CommentNode.scss";
import useVerifyConnection from "../../../../../hooks/useVerifyConnection";
import { RateReview } from "@mui/icons-material";

function CommentNode({ selected, isValid }) {
    const verifyConnection = useVerifyConnection();

    return (
        <>
            <Handle
                type="source"
                position="right"
                isValidConnection={verifyConnection}
                id="SUCCESS"
            />
            <Handle
                type="source"
                position="bottom"
                isValidConnection={verifyConnection}
                id="ERROR"
            />
            <div
                className={`comment-node-container${
                    selected ? " selected" : ""
                }`}
            >
                <div className="comment-content">
                    <RateReview fontSize="large" />
                </div>
                {isValid || <div className="invalid-marker"></div>}
            </div>
            <Handle
                type="target"
                position="left"
                isValidConnection={verifyConnection}
            />
        </>
    );
}

export default CommentNode;
